<template>
  <vs-popup
    classContent="popup-example"
    title="Select Merchant"
    :active.sync="show"
  >
    <div class="vx-row">
      <b-table
        ref="table"
        style="height: 600px;"
        striped
        hover
        fixed
        responsive
        show-empty
        sort-icon-left
        :selectable="false"
        :items="merchantList"
        :select-mode="`multi`"
        :fields="columns"
        :current-page="currentPage"
        :per-page="perPage"
        @row-clicked="myRowClickHandler"
      >
        <template v-slot:table-busy>
          <div class="text-center text-danger my-2" style="height:600px;">
            <b-spinner class="align-middle"></b-spinner>
            <div class="mt-3">
              <strong>Loading...</strong>
            </div>
          </div>
        </template>

        <template v-slot:cell(logo)="data">
          <div
            style="width:100px; height:50px; position:relative; text-align:center; padding-left:20px;"
          >
            <img :src="data.item.logo" class="header-logo" />
          </div>
        </template>

        <template v-slot:cell(name)="data">
          <h6>{{ data.item.name }}</h6>
        </template>

        <template v-slot:cell(action)="data">
          <div class="text-right">
            <vs-button @click="selectS(data.item)" color="primary" type="flat"
              >Select</vs-button
            >
          </div>
        </template>
      </b-table>
    </div>
  </vs-popup>
</template>
<script>
import { mapState } from "vuex";
import Service from "@/services";

export default {
  components: {},
  props: {
    showDialog: false
  },
  data: () => ({
    currentPage: 1,
    perPage: 30,
    totalRows: 0,
    columns: [
      { label: "", key: "logo", sortable: false },
      { label: "", key: "name", sortable: false }
    ],
    merchantList: [],
    s_list: [],
    e_upcoming_list: []
  }),
  computed: {
    show: {
      get() {
        if (this.showDialog) {
          this.loadSellers();
        } else {
        }
        return this.showDialog;
      },
      set(value) {
        if (!value) {
          this.$emit("close");
        }
      }
    }
  },
  methods: {
    loadSellers() {
      Service.Auth.getMySellers().then(res => {
        this.merchantList = res.data;
      });
    },
    selectS(seller) {
      this.$vs.loading();
      this.mode = "select_e";
      this.e_upcoming_list = [];
      this.$emit("submit", seller);
      this.$vs.loading.close();
      /*
      Service.Auth.updateProfile({ s: seller.s }).then(res => {
        if (res.success) {
          this.$store.dispatch("Utility/setMerchant", res.data.default.s);
          this.$router.replace({ query: { s: res.data.default.s } });
          this.mode = "select_e";
          this.e_upcoming_list = [];
        }

        this.$emit("submit", seller);
        this.$vs.loading.close();
      });
      */
    },
    myRowClickHandler(record, index) {
      this.selectS(record);
      // 'record' will be the row data from items
      // `index` will be the visible row number (available in the v-model 'shownItems')
      //console.log(record); // This will be the item data for the row
    }
  }
};
</script>
<style lang="scss" scoped>
.header-logo {
  max-height: 36px;
  padding-top: 2px;
  vertical-align: top;
  max-width: 120px;
  transform: translate(0%, 0%);
  left: 0px;
  right: 0;
}
</style>
